import { SEVERITY_DOT } from "../../lib/monitoring";

export default function SeverityDot({ severity, size = 10, label, className = "" }) {
  const tone = SEVERITY_DOT[severity] || SEVERITY_DOT.info;
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`}>
      <span
        className={`inline-block rounded-full ${tone}`}
        style={{ width: size, height: size }}
        aria-hidden="true"
      />
      {label !== undefined && (
        <span className="text-xs font-semibold capitalize text-slate-900">
          {label || severity}
        </span>
      )}
    </span>
  );
}
